var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2.5 L2.5,10.8611825 L13.5,10.8611825 L13.5,2.5 L2.5,2.5 Z M1,1.77635684e-13 L15,1.77524662e-13 C15.5522847,1.78404263e-13 16,0.44771525 16,1 L16,12.3611825 C16,12.9134673 15.5522847,13.3611825 15,13.3611825 L1,13.3611825 C0.44771525,13.3611825 6.76353751e-17,12.9134673 0,12.3611825 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.77737137e-13 1,1.77635684e-13 Z",
    id: "Rectangle",
    fill: "#006A35",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3892388,2.13732903 L24.3890162,8.07528176 C24.7815577,8.46377834 24.7848368,9.09693483 24.3963402,9.48947636 C24.2388381,9.64861836 24.032484,9.75029795 23.8103288,9.77822953 L16.9374237,10.6423602 C16.3894531,10.7112565 15.8893837,10.3228902 15.8204873,9.7749196 C15.8099638,9.69122046 15.8100735,9.60652609 15.8208137,9.52285449 L16.6939415,2.72077112 C16.7642569,2.17298084 17.2653305,1.78591093 17.8131208,1.85622628 C18.0308037,1.88416846 18.2332492,1.98294679 18.3892388,2.13732903 Z",
    id: "Path",
    fill: "#006A35",
    fillRule: "nonzero",
    transform: "translate(20.249128, 6.249128) rotate(45.000000) translate(-20.249128, -6.249128) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.acc4bf51a2123afed7e7d68ff9bc7d07.svg";
export { ForwardRef as ReactComponent };